import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'
import ContentEditable from 'react-contenteditable'
import SanitizeHtml from "sanitize-html";
import MessageUI from '../output/MessageUI'
import './InlineEdit.css'

class InlineEditUI extends Component {
  constructor(props) {
    super(props)
    this.contentEditable = React.createRef();
    this.cancelInitiated = false // esc invokes blur, onBlur needs to prevent additional processing
    this.updateInitiated = false // enter invokes blur, onBlur needs to prevent additional processing
    this.state = {
      value: this.htmlEntities(this.props.value),
    }
    this.class = 'InlineEditUI'
  }

  htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  }

  render() {
    return (
      <React.Fragment>
        <ContentEditable
          innerRef={this.contentEditable}
          className='w_inln_edit'
          html={this.state.value}  // innerHTML of the editable div
          disabled={!this.props.editable}         // TODO disable for viewers
          onChange={this.onChange} // handle innerHTML change
          onBlur={this.onBlur}
          onKeyUp={this.onKeyUp}
          onKeyDown={this.onKeyDown}
          onClick={this.onClick}
        />
        {/* called by onBlur // onClick={this.onUpdate} */}
        {
          this.props.editable &&
          <React.Fragment>
            <div
              className='icon icon-check g_link tag'
              onClick={this.onSave}
              style={{display: this.props.editMode ? 'inline-block' : 'none'}}
              data-tip data-for='t-save'
            >
              <ReactTooltip id='t-save'>
                <MessageUI messageList={this.props.messageList} messageKey='c_save' />
                <br/>[<MessageUI messageList={this.props.messageList} messageKey='c_kb_shortcut_save' />]
              </ReactTooltip>
            </div>
            <div
              className='icon icon-times g_link tag'
              onClick={this.onCancel}
              style={{display: this.props.editMode ? 'inline-block' : 'none'}}
              data-tip data-for='t-cancel'
            >
              <ReactTooltip id='t-cancel'>
                <MessageUI messageList={this.props.messageList} messageKey='c_cancel' />
                <br/>[<MessageUI messageList={this.props.messageList} messageKey='c_kb_shortcut_cancel' />]
              </ReactTooltip>
            </div>
          </React.Fragment>
        }
      </React.Fragment>
    )
  }

  componentDidMount() {
    if (this.props.dataId === 'create') {
      this.contentEditable.current.focus()
      let tmp = this.state.value
      this.setState({value: ''}, () => this.setState({value: tmp}))
    }
  }

  onChange = (event) => {
    this.setState({value: event.target.value})
  }

  onClick = (event) => {
    event.stopPropagation()
    console.log('onClick', this.props.value)
    if (this.props.editMode) {
      return
    }
    // following situation happens when one task is being edited and another task name is clicked
    if (this.props.editingOther) {
      this.contentEditable.current.blur()
      return
    }
    this.props.onSetEditMode(this.props.dataId, true)
  }

  onBlur = (event) => {
    console.log('onBlur', this.props.value, '-----')
    event.persist() // see react synthetic event
    // onBlur causes many problems if trying to update
    // when canceling, update gets called
    // when updating, cancel gets called
    // excute update in a timeout so cancel event is executed before onBlur
    setTimeout(() => {
      console.log('onBlur after timeout -----')
      if (this.cancelInitiated) {
        console.log('onBlur cancelInitiated')
        this.cancelInitiated = false
        return
      }
      if (this.updateInitiated) {
        console.log('onBlur updateInitiated')
        this.updateInitiated = false
        return
      }
      this.onUpdate(event)
    }, 1000);
  }

  onKeyUp = (event) => {
    switch (event.keyCode) {
      case 13: // enter
        if (!event.shiftKey) {
          console.log('onKeyUp', event.keyCode, '-----')
          this.onUpdate(event)
          this.updateInitiated = true
          document.activeElement.blur()
        }
        break
      default:
    }
  }

  onKeyDown = (event) => {
    // console.log('onKeyDown', event.keyCode)
    switch (event.keyCode) {
      case 13: // enter
        console.log('onKeyDown', event.keyCode, '-----')
        event.preventDefault()
        event.stopPropagation()
        break;
      case 27: // escape
        console.log('onKeyDown', event.keyCode, '-----')
        event.stopPropagation()
        this.onCancel(event)
        document.activeElement.blur()
        break
      default:
    }
  }

  onSave = (event) => {
    console.log(this.class, 'onSave')
    this.onUpdate(event)
    this.updateInitiated = true
  }

  // tests: 1. enter key, 2. save icon, 3. click outside
  onUpdate = (event) => {
    // remove html encoding here
    let value = SanitizeHtml(this.state.value, {
      allowedTags: [],
      allowedAttributes: {}
    })

    const tmp = document.createElement('div');
    tmp.innerHTML = value.trim();

    console.log('onUpdate', this.props.value, '-', tmp.textContent)
    event.stopPropagation()

    if (this.props.value === tmp.textContent && this.props.dataId !== 'create') {
      this.setState({
        value: this.props.value,
      })
      this.props.onSetEditMode(this.props.dataId, false)
      return
    }

    this.props.onValueUpdate(this.props.dataId, tmp.textContent)
  }

  // tests: 1. esc key, 2. cancel icon
  onCancel = (event) => {
    console.log('onCancel', this.props.value, '-', this.state.value, '-----')
    event.stopPropagation()
    this.cancelInitiated = true
    this.setState({
      value: this.props.value,
    })
    this.props.onSetEditMode(this.props.dataId, false)
  }
}

export default InlineEditUI
